import {$$, wrapLinkWithBiEvent} from '../../utils';
import * as footerMobileCss from './mobile.scss';
import * as accordionCss from './components/Accordion/Accordion.scss';
import * as bi from '../../bi';
import {bindAccordionClickListeners} from './components/Accordion/Accordion';

export function removeAttributeFromLinks() {
  $$(`.${footerMobileCss.container} a`).forEach(link => link.setAttribute('target', ''));
  return this;
}

export function bindClicks() {
  $$(`.${footerMobileCss.container} a`)
    .forEach(link => wrapLinkWithBiEvent(bi.legacyHeaderAndFooterBiLogger, link, bi.legacyhfConfig.clickOnFooter, link => {
      const button_name = link.dataset.biName;  // eslint-disable-line
      const type = link.closest(`.${accordionCss.panel}`).dataset.biName;
      const url = encodeURIComponent(window.location.href);
      return {button_name, type, url}; // eslint-disable-line
    }));
  bindAccordionClickListeners();
}
